<template>
  <div id="registration-away">
    <div v-if="isLoading" class="loader-container">
      <el-loading :fullscreen="true" text="Carregando..." />
    </div>
    <div v-if="hasAvailableVoucher">
      <div id="doctor-registration"></div>
      <div class="text-spacing">
        <el-text type="danger" class="text-spacing">
          Caso Clínico: {{ decodedContractName }}
          <br />
        </el-text>
      </div>
      <div class="text-spacing">
        <el-text class="text-spacing">
          Seja muito bem vindo(a) a plataforma Medical Second Opinion - MeSO.<br />
        </el-text>
      </div>
      <div class="text-spacing">
        <el-text>
          Por meio da plataforma MeSO você terá a oportunidade de analisar um
          caso clínico junto a um de nossos consultores médicos especialistas,
          auxiliando-o na avaliação sobre o diagnóstico e manejo do paciente
          envolvido. Todo o processo será realizado via plataforma MeSO, com
          total sigilo e segurança dos dados trocados durante o processo,
          resguardando a privacidade dos pacientes envolvidos, de acordo com a
          legislação vigente.<br />
        </el-text>
      </div>
      <h2>
        Por favor, informe os dados abaixo para realizar o seu cadastramento e
        ter acesso ao caso clínico.
      </h2>
      <div class="form">
        <div class="form">
          <input-group>
            <input-wrapper>
              <el-input
                v-model="name"
                placeholder="Nome"
                class="flexible-input"
                type="text"
              />
            </input-wrapper>
            <input-wrapper>
              <el-input
                v-model="cpf"
                placeholder="CPF"
                class="flexible-input"
                type="text"
                v-mask="'###.###.###-##'"
                @blur="validateCPF"
              />
              <span v-if="cpfError" class="error-message">CPF inválido</span>
            </input-wrapper>
          </input-group>
          <input-group>
            <input-wrapper>
              <el-input
                v-model="email"
                placeholder="E-mail"
                class="flexible-input"
                type="email"
              />
            </input-wrapper>
            <input-wrapper>
              <el-input
                v-model="phone"
                placeholder="Telefone"
                class="flexible-input"
                v-mask="['(##) ####-####', '(##) # ####-####']"
                type="text"
              />
            </input-wrapper>
          </input-group>
          <input-group>
            <input-wrapper>
              <el-input
                v-model="crm"
                placeholder="CRM"
                class="flexible-input"
                type="text"
              />
            </input-wrapper>
            <input-wrapper>
              <el-select
                v-model="uf_crm"
                size="large"
                filterable
                clearable
                placeholder="UF CRM"
              >
                <el-option
                  v-for="option in ufOptions"
                  :key="option.value"
                  :label="option.label"
                  :value="option.value"
                />
              </el-select>
            </input-wrapper>
            <input-wrapper>
              <el-input
                v-model="password"
                placeholder="Senha"
                class="flexible-input"
                type="password"
                show-password
              />
            </input-wrapper>
          </input-group>
        </div>

        <div class="terms-agreement">
          <label>
            <input type="checkbox" id="termsCheckbox" v-model="termsAgreed" />
            Li e estou de acordo com o
            <span @click="openModal">Termo de Responsabilidade</span>
            sobre a Execução dos Serviços
          </label>
          <el-dialog
            v-model="modalTermsVisible"
            @close="closeModal"
            title="Termo de Responsabilidade"
          >
            <div ref="modalContent">
              <div ref="scrollbarRef" class="modal-text">
                <p>
                  <strong
                    >Termos de Uso da Plataforma MeSO – Médico
                    Solicitante</strong
                  >
                </p>
                <p>
                  <strong>(a)</strong> Estes Termos de Uso da Plataforma MeSO
                  <strong>(“Termos de Uso”)</strong> disciplinam o acesso, uso e
                  funcionamento da funcionamento da Plataforma MeSO,
                  disponibilizada pelo
                  <strong>INSTITUTO CEOS LTDA.,</strong> com sede na Rua Alcides
                  Gonzaga, nº 300, Sala 1602, bairro Boa Vista, CEP 90.480-020,
                  em Porto Alegre/RS, inscrita no CNPJ sob o nº
                  44.142.221/0001-70 e filial na Av. Ipiranga, nº 1801, Andar 7,
                  bairro Praia de Belas, CEP 90.160-092, em Porto Alegre/RS,
                  inscrita no CNPJ sob o nº 44.142.221/0002-50
                  <strong>(“Instituto CEOS”).</strong>
                </p>
                <p>
                  <strong>(b)</strong> O usuário deve
                  <strong
                    >LER INTEGRALMENTE ESTES TERMOS DE USO, COM ATENÇÃO,</strong
                  >
                  pois a utilização da Plataforma MESO está
                  <strong
                    >sujeita à sua integral concordância e ao seu aceite a estes
                    Termos de Uso,</strong
                  >
                  bem como à Política de Privacidade do Instituto CEOS.
                </p>
                <p>
                  <strong>(c)</strong> Na hipótese de
                  <strong
                    >não concordância com qualquer cláusula ou condição prevista
                    nestes Termos de Uso ou na Política de Privacidade, o
                    usuário não deverá acessar ou, de qualquer forma, utilizar a
                    Plataforma MeSO,</strong
                  >
                  pois toda pessoa que fizer login da Plataforma MeSO estará
                  submetido integralmente às disposições dos Termos de Uso,
                  renunciando renunciando implicitamente qualquer alegação de
                  divergência sobre as condições ora estabelecidas.
                </p>
                <p>
                  (d) O usuário entende e reconhece que estes Termos de Uso e a
                  Política de Privacidade têm a natureza jurídica de contrato
                  bilateral e declara que o acesso e/ou a utilização da
                  Plataforma MeSO implicará no automático aceite e sujeição das
                  cláusulas e condições dos Termos de Uso.
                </p>
                <p>
                  <strong>1. Definições:</strong>
                </p>
                <p>
                  <strong>1.1.</strong> Além dos termos definidos inseridos ao
                  longo destes Termos Termos de Uso, identificados entre
                  parênteses, entre aspas, palavra iniciada com letra maiúscula,
                  sublinhada e em negrito, para facilitar a compreensão e
                  interpretação dos direitos e obrigações previstos no presente
                  Termo, são adotadas as seguintes definições:
                </p>
                <p>
                  <strong>“Médico Consultor”</strong> usuário da Plataforma
                  MeSO, devidamente habilitado e autorizado para o exercício da
                  medicina, que prestará Serviços MeSO, conforme atribuições e
                  especificações determinadas e aplicáveis para o seu perfil, de
                  acordo com as suas respectivas áreas de atuação;
                </p>
                <p>
                  <strong>“Médico Solicitante”</strong> usuário da Plataforma
                  MeSO, devidamente habilitado e autorizado para o exercício da
                  medicina, que deseja solicitar um Parecer MeSO;
                </p>
                <p>
                  <strong>“Plataforma MeSO”</strong> é uma plataforma
                  disponibilizada pelo Instituto CEOS, baseada em software, que
                  permite aos seus usuários a solicitação de um Parecer MeSO
                </p>
                <p>
                  <strong>2. Objeto:</strong>
                </p>
                <p>
                  <strong>2.1</strong> Estes Termos de Uso contêm regras gerais
                  para acesso, uso e funcionamento da Plataforma MeSO,
                  disponibilizada pelo Instituto CEOS, cuja finalidade é de
                  disponibilizar aos Médicos Solicitantes serviços de Medical
                  Second Opinion <strong>(“Serviços MeSO”)</strong>, que
                  resultarão na produção de um parecer com segunda opinião
                  médica sobre casos clínicos <strong>(“Parecer MeSO”)</strong>,
                  os quais serão elaborados por Médicos Consultores cadastrados
                  na Plataforma MeSO.
                </p>
                <p>
                  <strong>2.2</strong> Os Serviços MeSO serão prestados pelos
                  Médicos Consultores em conformidade com estes Termos de Uso e
                  com os respectivos instrumentos jurídicos aplicáveis para
                  reger a relação contratual com o Instituto CEOS.
                </p>
                <p>
                  <strong>2.3</strong> O Instituto CEOS não exercerá nenhuma
                  ingerência, intervenção ou se envolverá com as atividades dos
                  Médicos Consultores ou Médicos Solicitantes no que tange aos
                  Serviços MeSO, qualquer atividade de natureza médica,
                  especialmente com relação à produção ou conteúdo do(s)
                  Parecer(es) MeSO, exceto quanto à gestão administrativa,
                  operacional e financeira da Plataforma MeSO.
                </p>
                <p>
                  <strong>2.4</strong> Os Médicos Consultores e os Médicos
                  Solicitantes são exclusivamente responsáveis pelo exercício
                  das suas atividades médicas e pelo cumprimento da legislação
                  vigente e das normas aplicáveis aos profissionais da medicina,
                  assim como pela utilização da e das normas aplicáveis aos
                  profissionais da medicina, assim como pela utilização da
                  Plataforma MeSO em conformidade com todos os preceitos éticos
                  e profissionais.
                </p>
                <p>
                  <strong>3. Plataforma MeSO:</strong>
                </p>
                <p>
                  <strong>3.1</strong>Cada usuário da Plataforma MeSO deverá
                  criar uma conta individual, cujo uso será pessoal e
                  intransferível, ficando expressamente proibido qualquer tipo
                  de cessão, compartilhamento, divulgação, transferência ou
                  ainda permissão de uso por terceiros da conta de cada usuário.
                  O Instituto CEOS não poderá ser responsabilizado por eventual
                  uso da conta do usuário por terceiros.
                </p>
                <p>
                  <strong>3.2</strong>Somente poderão ser incluídas na
                  Plataforma MeSO informações verdadeiras e condizentes com a
                  realidade, assumindo o usuário todas as consequências de
                  quaisquer omissões, declarações falsas, inverídicas,
                  incorretas ou incompletas.
                </p>
                <p>
                  <strong>3.3</strong>O usuário está ciente de que todos os
                  dados e informações são disponibilizados pelo próprio usuário,
                  e o Instituto CEOS não tem qualquer obrigação de garantir a
                  veracidade das referidas informações. O Instituto CEOS,
                  portanto, não é responsável pelos dados fornecidos, nem mesmo
                  por mensagens, publicidades, arquivos, imagens, fotos, vídeos,
                  sons ou qualquer outro material disponibilizado pelos
                  usuários, pelos quais estes respondem integral, exclusiva e
                  pessoalmente.
                </p>
                <p>
                  <strong>3.4</strong>O Instituto CEOS se reserva o direito de,
                  caso suspeitar da eventual prática de ato ilícito, qualquer
                  que seja a sua natureza, ou que possa configurar violação aos
                  Termos de Uso, de adotar as providências e medidas legais
                  cabíveis para verificar a regularidade do uso do Plataforma
                  MeSO e eventual comunicação das autoridades governamentais
                  competentes para investigação e apuração sobre atos ilícitos,
                  inclusive compartilhando dados, informações e documentos.
                </p>
                <p>
                  <strong>3.5</strong>Havendo a constatação da irregularidade do
                  uso da Plataforma MeSO, o usuário poderá ser suspenso ou ter a
                  sua conta cancelada.
                </p>
                <p>
                  <strong>3.6</strong>São obrigações gerais para todos os
                  usuários da Plataforma MeSO: (a) fazer uso lícito da
                  Plataforma MeSO, cumprindo e observando toda a legislação
                  aplicável, bem como as regras previstas neste Termos de Uso e
                  na Política de Privacidade; (b) manter a confidencialidade de
                  seu login e senha de acesso, e por restringir o acesso ao
                  dispositivo utilizado para acessar a Plataforma MeSO,
                  responsabilizando-se; (c) fornecer as informações verídicas e
                  corretas durante o cadastramento e o uso da Plataforma MeSO;
                  (d) responsabilizar-se por todas as atividades promovidas a
                  partir de sua conta, inclusive sobre todo o conteúdo que
                  inserir na Plataforma MeSO, pelos direitos autorais e violação
                  de direito de imagem ou de propriedade intelectual de
                  terceiros, sendo proibido o uso de imagens, textos, vídeos e
                  demais arquivos cujo conteúdo desrespeite os princípios da
                  moral, ética, os bons costumes e a legislação vigente; (e)
                  notificar imediatamente o Instituto CEOS sobre qualquer uso
                  não autorizado de sua conta na Plataforma MeSO, qualquer
                  quebra de segurança de seu conhecimento ou suspeitar de ações
                  maliciosas de terceiros; (f) anonimizar os dados pessoais dos
                  pacientes antes de inserir qualquer conteúdo na Plataforma
                  MeSO, de forma que se torne impossível a identificação do
                  paciente; (g) indenizar, defender, eximir, manter indene e,
                  quando aplicável, reembolsar o Instituto CEOS ou terceiros,
                  direta ou indiretamente em relação a todo e qualquer prejuízo,
                  indenização, responsabilidade, danos (pessoal e material),
                  desembolsos, adiantamentos, tributos e despesas (inclusive
                  honorários e despesas com advogados) pagos e/ou incorridos
                  pela parte inocente, direta ou indiretamente, em razão da
                  prática de ato ilícito, violação das normas regulatórias
                  aplicáveis ou descumprimento destes Termos de Uso, assegurado
                  desde já ao direito de regresso e de denunciação à lide, na
                  forma do artigo 125, inciso II, do Código de Processo Civil; e
                  (h) acessar a Plataforma MeSO diariamente, verificar as suas
                  notificações, mensagens e as atualizações de casos clínicos;
                  (h) cumprir e fazer cumprir a legislação, normas, e
                  regulamentos aplicáveis, de acordo com os padrões
                  internacionais exigidos para o exercício das atividades
                  médicas.
                </p>
                <p>
                  <strong>3.7</strong>Os usuários são expressamente proibidos
                  de: (a) copiar, ceder, licenciar, sublicenciar, vender,
                  alugar, dar em locação ou em garantia, distribuir,
                  compartilhar, reproduzir, doar, alienar de qualquer forma,
                  disponibilizar, dar acesso à Plataforma MeSO ou transferir
                  total ou parcialmente, sob quaisquer modalidades, gratuita ou
                  onerosamente, provisória ou permanentemente, os Serviços MeSO,
                  Parecer(es) MeSO ou qualquer tipo de conteúdo disponibilizado
                  na Plataforma MeSO; (b) empregar softwares, técnicas e/ou
                  artifícios com o intuito de utilizar indevidamente a
                  Plataforma MeSO para práticas nocivas ao Instituto CEOS ou a
                  terceiros, tais como hacking, scraping, crawling, exploits,
                  spamming, flooding, spoofing, crashing, root kits, etc; (c)
                  utilizar a Plataforma MeSO para outras finalidades, incluindo
                  o desenvolvimento de atividades ou produtos concorrentes ou
                  semelhantes; (d) veicular na Plataforma MeSO informação que
                  instigue a qualquer forma de atividades ilícitas, de assédio,
                  bullying, conteúdo de natureza preconceituosa, , vexatório,
                  difamatório, invasivo à privacidade, abusivo, ameaçador,
                  prejudicial, vulgar, obsceno, injurioso, ou de qualquer forma
                  censurável, ameaçador, racista, que incite violência e o uso
                  de drogas, pedofilia, zoofilia, crueldade ou qualquer outro
                  ato que atente aos bons costumes e à moral; e (e)
                  compartilhar, disponibilizar, transmitir, dar conhecimento ou
                  acesso de dados pessoais de pacientes com outros usuários.
                </p>
                <p>
                  <strong>3.8</strong>O Instituto CEOS se reserva o direito de
                  exercer prévia moderação em todo conteúdo publicado pelos
                  usuários, podendo rever, modificar, filtrar, remover, no todo
                  ou em parte, qualquer conteúdo que possa configurar como
                  violação aos Termos de Uso.
                </p>
                <p>
                  <strong>3.9</strong>O Instituto CEOS poderá, ao seu exclusivo
                  critério, a qualquer tempo, e sem a necessidade de comunicação
                  prévia, acrescentar, excluir ou modificar as funcionalidades e
                  os conteúdos oferecidos na Plataforma MeSO, assim como a
                  própria Plataforma MeSO. O Instituto CEOS não se compromete a
                  manter ativa qualquer ferramenta, funcionalidade ou serviço
                  que já tenha sido oferecido no passado por meio da Plataforma
                  MeSO.
                </p>
                <p>
                  <strong>3.10</strong>A Plataforma MeSO é um mero instrumento
                  para prestação dos Serviços MeSO, tratando-se de um mecanismo
                  de meio, não exercendo o Instituto CEOS nenhum dos Serviços
                  MeSO como atividade fim, que são atribuições exclusivas do
                  Médico Consultor.
                </p>
                <p>
                  <strong
                    >4. Obrigações e Responsabilidades do Médico
                    Consultor:</strong
                  >
                </p>
                <p>
                  <strong>4.1</strong> O Médico Consultor será responsável por
                  produzir um Parecer para cada caso clínico que manifestar seu
                  aceite após a designação pela plataforma.
                </p>
                <p>
                  <strong>4.2</strong> Em um prazo de até 72 (setenta e duas)
                  horas contados do recebimento do aviso de designação para um
                  caso clínico, o Médico Consultor deverá manifestar o seu
                  aceite na Plataforma MeSO. Se não houver manifestação do
                  Médico Consultor no prazo assinalado, o caso clínico será
                  automaticamente redesignado para um Médico Consultor suplente.
                </p>
                <p>
                  <strong>4.3</strong> Se o Médico Solicitante expor o nome ou
                  dados de identificação do paciente do caso clínico, o Médico
                  Consultor deverá comunicar o Instituto CEOS, que procederá na
                  imediata exclusão dos documentos. O Médico Consultor não
                  poderá fazer qualquer menção ou referência sobre qualquer
                  informação pessoal do paciente que vier a ter conhecimento,
                  nem mesmo nas mensagens, registros ou conteúdos inseridos na
                  Plataforma MeSO.
                </p>
                <p>
                  <strong>4.4</strong> Na hipótese de o Médico Consultor
                  identificar a necessidade de solicitar esclarecimentos, fazer
                  questionamentos ou pedir complementação da documentação do
                  paciente ou relacionado ao caso clínico, o Médico Consultor
                  deverá utilizar apenas a Plataforma MeSO para se comunicar com
                  o Médico Solicitante. Não deverá ser estabelecida qualquer
                  tipo de comunicação entre o Médico Consultor e o Médico
                  Solicitante fora da plataforma. Caso seja recebido algum
                  contato externo nesse sentido, aquele que for contatado deve
                  recusar imediatamente dar prosseguimento na comunicação fora
                  da Plataforma MeSO.
                </p>
                <p>
                  <strong>4.5</strong> Todas as mensagens, documentos e
                  conteúdos inseridos na Plataforma MeSO serão tratadas como
                  Informações Confidenciais, na forma da legislação vigente e
                  legislação aplicável, não poderão ser armazenadas, seja de
                  forma digital ou física, após a entrega do Parecer fora da
                  Plataforma MeSO. Contudo, caso haja a redesignação do Médico
                  Consultor após o aceite do caso clínico, será concedido acesso
                  irrestrito ao Médico Consultor suplente a tudo que for
                  relacionado ao caso clínico.
                </p>
                <p>
                  <strong>4.6</strong> O prazo de conclusão do Parecer será de 7
                  (sete) dias contados da data do recebimento da comunicação de
                  designação, não havendo qualquer interferência a data que
                  tenha havido o aceite. Em caso de descumprimento do prazo, o
                  caso médico poderá ser redesignado para o Médico Consultor
                  suplente.
                </p>
                <p>
                  <strong>4.7</strong> Caso o Médico Consultor apresente alguma
                  solicitação ou questionamento ao Médico Solicitante pela
                  Plataforma MeSO, o prazo da
                  <strong>Cláusula 4.6</strong> poderá ser ampliado por mais 3
                  (três) dias contados da data da resposta final do Médico
                  Solicitante.
                </p>
                <p>
                  <strong>4.8</strong> Todas as solicitações e questionamentos
                  do Médico Consultor deverão ser devidamente fundamentadas e
                  justificadas. Caso o Instituto CEOS constate que o Médico
                  Consultor apresentou solicitação ou questionamento infundado
                  para prorrogação do prazo, o caso médico poderá ser
                  redesignado e o Médico Consultor ficará sujeito a suspensão ou
                  outras penalidades que estiverem expressamente previstas
                  nestes Termos de Uso ou em outros instrumentos jurídicos
                  contratuais.
                </p>
                <p>
                  <strong>4.9</strong> O Parecer produzido pelo Médico Consultor
                  deverá se limitar a fazer uma análise do caso clínico, com
                  base nos elementos que forem apresentados pelo Médico
                  Solicitante e fundamentado na literatura médica, não podendo o
                  Médico Consultor fazer diagnóstico sobre a condição de saúde
                  do paciente, nem prescrever medicação específica ou
                  tratamento, mas tão somente fazer análises comparativas de
                  soluções médicas e alternativas que poderiam ser adotadas.
                </p>
                <p>
                  <strong>4.10</strong> O Médico Consultor terá direito ao
                  recebimento de honorários médicos por cada Parecer produzido e
                  incluído tempestivamente na Plataforma, conforme
                  especificações do respectivo contrato de prestação de serviços
                  a ser celebrado com o Instituto CEOS.
                </p>
                <p>
                  <strong>4.11</strong> No 5º (quinto) dia útil de cada mês, o
                  Instituto CEOS encaminhará ao Médico Consultor um relatório
                  sobre a quantidade de casos clínicos e Pareceres concluídos no
                  mês anterior e informar os honorários médicos que terá direito
                  ao recebimento.
                </p>
                <p>
                  <strong>4.12</strong> Os honorários médicos serão pagos até o
                  15º (décimo quinto) dia útil do mês subsequente ao envio do
                  relatório.
                </p>
                <p>
                  <strong>4.13</strong> Em qualquer hipótese de redesignação do
                  Médico Consultor, somente aquele Médico Consultor que
                  efetivamente produzir o parecer terá direito ao recebimento
                  dos honorários, ainda que inicialmente algum Médico Consultor
                  aceite a designação, independentemente de ter havido qualquer
                  tipo de análise do caso clínico, produção de conteúdo ou troca
                  de mensagens com o Médico Solicitante.
                </p>
                <p>
                  <strong>4.14</strong> O Instituto CEOS não fará qualquer tipo
                  de revisão sobre o conteúdo do(s) Parecer(es) produzidos pelos
                  Médicos Consultores, sendo de exclusiva e integral
                  responsabilidade do Médico Consultor o seu conteúdo ou o
                  cumprimento das obrigações assumidas pelo Médico Consultor.
                </p>
                <p>
                  <strong>4.15</strong> A responsabilidade pela escolha no
                  atendimento, prescrição de remédios e tratamentos adequados ao
                  paciente é integralmente do Médico Solicitante, não cabendo
                  qualquer vínculo e/ou responsabilidade profissional ao Médico
                  Consultor e ao Instituto CEOS.
                </p>
                <p>
                  <strong>5. Propriedade Intelectual</strong>
                </p>
                <p>
                  <strong>5.1</strong> Estes Termos de Uso concedem ao usuário
                  uma licença pessoal, revogável, não exclusiva, temporária e
                  intransferível de uso da Plataforma MeSO para o fim exclusivo
                  ora previsto. Essa licença não concede ao usuário o direito de
                  usar a Plataforma MeSO para qualquer propósito que não esteja
                  previsto expressamente nestes Termos de Uso.
                </p>
                <p>
                  <strong>5.2</strong> Em nenhuma hipótese o usuário terá acesso
                  ao código-fonte do software usado na Plataforma MeSO, já que
                  esse é, e permanecerá sendo, sigiloso e de propriedade
                  intelectual única e exclusiva do Instituto CEOS.
                </p>
                <p>
                  <strong>5.3</strong> O usuário não adquire, por meio destes
                  Termos de Uso, nenhum direito de propriedade intelectual ou
                  outros direitos sobre quaisquer patentes, desenhos, bases de
                  dados, marcas, direitos autorais, conteúdos ou direitos sobre
                  informações confidenciais ou segredos de negócio, sobre ou
                  relacionados à Plataforma MeSO, os quais são e continuarão
                  sendo de propriedade exclusiva do Instituto CEOS.
                </p>
                <p>
                  <strong>5.4</strong> Qualquer desenvolvimento de um produto
                  que caracterize cópia, no todo ou em parte, quer seja do banco
                  de dados, quer seja do software, esse será considerado como
                  parte do software usado na Plataforma MeSO, ficando, portanto,
                  sua propriedade incorporada pelo Instituto CEOS e seu uso
                  condicionado aos termos destes Termos de Uso, sem que qualquer
                  remuneração seja devida pelo Instituto CEOS e ficando o
                  usuário impedido de utilizar, comercializar ou, de outra
                  forma, explorar referido módulo ou produto.
                </p>
                <p>
                  <strong>5.5</strong> Todos e quaisquer direitos de propriedade
                  intelectual relacionados à Plataforma MeSO ou ao conteúdo
                  disponibilizado na Plataforma MeSO, tais como, mas não se
                  limitando a, textos, imagens, vídeos, sons, ilustrações,
                  gráficos, dados, logos, ícones, fotografias, conteúdo
                  editorial, notificações, softwares, programas de computador,
                  códigos-fonte, ícones, trade-dress e qualquer outro material,
                  incluindo a seleção e a organização desses materiais,
                  pertencem, e continuarão pertencendo, exclusivamente ao
                  Instituto CEOS ou ao seu titular originário de direitos, e são
                  protegidos pela lei brasileira no que se refere à propriedade
                  intelectual e aos direitos autorais, sendo que o acesso a
                  conteúdo de terceiros não possibilita ao usuário fazer
                  qualquer tipo de uso indevido ou reinvindicação de
                  titularidade.
                </p>
                <p>
                  <strong>6. Sigilo e Confidencialidade:</strong>
                </p>
                <p>
                  <strong>6.1</strong> Todas e quaisquer informações, dados e/ou
                  materiais disponibilizadas na Plataforma MeSO, e/ou que tenham
                  sido obtidas por alguma como uma consequência direta ou
                  indireta da sua utilização serão consideradas como informações
                  confidenciais (“Informações Confidenciais”), continuarão sendo
                  de propriedade exclusiva da Parte reveladora.
                </p>
                <p>
                  <strong>6.2</strong> Os usuários da Plataforma MeSO manterão
                  as Informações Confidenciais sob sigilo e tratar com
                  confidencialidade, durante todo o período de utilização da
                  Plataforma MeSO e por um período adicional de 5 (cinco) anos
                  após eventual cancelamento ou desativação da conta do usuário,
                  ainda, sob hipótese alguma, farão uso ou revelará as
                  Informações Confidenciais, exceto se necessário para a
                  execução dos Serviços MeSO ou para o atendimento de ordens
                  judiciais ou de autoridades com poderes legítimos de
                  fiscalização sobre o objeto deste Contrato.
                </p>
                <p>
                  <strong>6.3</strong> Nenhum dos usuários poderá revelar,
                  transmitir, compartilhar, permitir o acesso, reproduzir ou de
                  qualquer forma disponibilizar, no todo ou em parte, as
                  Informações Confidenciais para terceiros, exceto se prévia e
                  expressamente autorizado.
                </p>
                <p>
                  <strong>6.4</strong> As obrigações de confidencialidade
                  previstas no Contrato não se aplicarão às Informações
                  Confidenciais que: (a) sejam comprovadamente de conhecimento
                  do público antes da criação da conta do usuário; (b) eram
                  comprovadamente conhecidas pelo usuário ao tempo de sua
                  revelação, não tendo sido obtidas, direta ou indiretamente,
                  pela usuário ou de terceiros sujeitos ao dever de sigilo; (c)
                  se tornaram conhecidas do público, em caráter geral, sem a
                  prática de ato ilícito ou violação de obrigação de sigilo e
                  confidencialidade; e (d) sejam reveladas pelo usuário em razão
                  de norma legal, ordem judicial ou por determinação de
                  autoridade judicial ou administrativa competente.
                </p>
                <p>
                  <strong>6.5</strong> Se o usuário for obrigado a revelar, no
                  todo ou em parte, qualquer Informação Confidencial por
                  determinação de juízo ou autoridade competente, antes de
                  realizar qualquer revelação, deverá: (a) comunicar por escrito
                  imediatamente ao Instituto CEOS sobre a existência de tal
                  determinação para que esta possa tomar todas e quaisquer
                  medidas legais cabíveis para minimizar os efeitos que a
                  divulgação de tais Informações Confidenciais possa causar; (b)
                  usar esforços razoáveis para obter tratamento confidencial a
                  quaisquer Informações Confidenciais divulgadas dessa forma; e
                  (c) revelar apenas a parte das Informações Confidenciais
                  expressamente requerida pela lei, ordem de revelação recebida.
                </p>
                <p>
                  <strong>6.6</strong> Nenhuma Informação Confidencial poderá
                  ser armazenada fora da Plataforma MeSO, salvo pelo período
                  necessário para prestação dos Serviços MeSO ou para o
                  cumprimento de obrigação legal.
                </p>
                <p>
                  <strong>7. Limitação de Responsabilidades</strong>
                </p>
                <p>
                  <strong>7.1</strong> O uso que o usuário faz da Plataforma
                  MeSO é de sua inteira responsabilidade e risco. De maneira
                  geral e na máxima extensão permitida pela lei, o Instituto
                  CEOS se exime de quaisquer garantias e/ou responsabilidades,
                  expressas ou implícitas, decorrentes ou relativas à utilização
                  da Plataforma MeSO, senão as obrigações expressamente
                  assumidas nos instrumentos contratuais que regerem a relação
                  com o usuário e previstas na legislação vigente.
                </p>
                <p>
                  <strong>7.2</strong>O Instituto CEOS não poderá ser
                  responsabilizado nas seguintes hipóteses: (a) acesso não
                  autorizado de terceiros à conta dos usuários da Plataforma
                  MeSO; (b) por atos praticados pelo usuário ou por terceiros
                  que tenham tido acesso à conta do usuário, assim como por
                  eventual descumprimento de obrigação assumida pelo usuário na
                  Plataforma MeSO; (c) eventos de caso fortuito ou força maior,
                  nos termos do artigo 393 do Código Civil; (d) danos causados
                  por programas nocivos à Plataforma, tais como, mas sem se
                  limitar a vírus, trojans e hackers, malwares e ransomwares;
                  (e) por dados, informações e conteúdos disponibilizados por
                  quaisquer usuários, próprios, de terceiros ou de pacientes; e
                  (f) por nenhum conselho, recomendação, diagnóstico, prescrição
                  médica, tratamento e/ou qualquer outro cuidado ou orientação
                  fornecida pelos usuários na Plataforma MeSO ou por outros
                  meios.
                </p>
                <p>
                  <strong>8. Disposições Gerais</strong>
                </p>
                <p>
                  <strong>8.1</strong>Estes Termos de Uso entram em vigor na
                  data em que disponibilizados na Plataforma MeSO e poderão ser
                  alterados periodicamente. Caso haja qualquer alteração, o
                  usuário será notificado pela Plataforma MeSO e permanecerá
                  vinculado às suas disposições enquanto sua conta estiver
                  ativa.
                </p>
                <p>
                  <strong>8.2</strong>Exceto quando o consentimento expresso for
                  obrigatório, a continuidade da utilização da Plataforma MeSO
                  e/ou a falta de oposição ou revogação do consentimento do
                  usuário implicará na aceitação de eventuais modificações a
                  estes Termos de Uso.
                </p>
                <p>
                  <strong>8.3</strong>Caso qualquer disposição destes Termos de
                  Uso seja considerada inexequível ou inválida, essa disposição
                  será isoladamente invalidada e não atingirá o restante das
                  disposições destes Termos de Uso.
                </p>
                <p>
                  <strong>8.4</strong>Eventuais atitudes de tolerância ou
                  flexibilidade, por quaisquer das Partes, no tocante à
                  exigência das obrigações pactuadas no presente Contrato, não
                  deverá ser considerada como alteração, renúncia e/ou novação
                  das obrigações aqui estatuídas, que permanecerão íntegras para
                  todos os fins e efeitos de direito.
                </p>
                <p>
                  <strong>8.5</strong>Qualquer fiscalização realizada por alguma
                  das Partes no âmbito deste Contrato de forma alguma importa em
                  exoneração, isenção ou transferência de responsabilidade da
                  outra Partes, tratando-se de mero exercício regular de
                  direito.
                </p>
                <p>
                  <strong>8.6</strong>Estes Termos de Uso serão regidos pela
                  legislação brasileira. Fica eleito o Foro Central da Comarca
                  de Porto Alegre/RS, como único competente para dirimir
                  quaisquer questões decorrentes da execução do presente Acordo,
                  com exclusão de qualquer outro, por mais privilegiado que
                  seja.
                </p>
              </div>

              <el-button class="modal-btn" type="primary" @click="handleTerms"
                >De acordo</el-button
              >
            </div>
          </el-dialog>
          <div class="save">
            <el-button
              type="primary"
              @click="handleSave"
              :disabled="isSaveDisabled"
              >Salvar</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <div v-else class="no-vouchers-message">
      <el-alert
        title="Sem vouchers disponíveis"
        type="warning"
        description="Não há vouchers disponíveis para esse contrato no momento."
        :closable="false"
        show-icon
      >
      </el-alert>
    </div>
  </div>
</template>

<script>
import CryptoJS from 'crypto-js'
import { useRouter } from 'vue-router'
import { useToast } from 'vue-toastification'
import { mapGetters, mapActions, mapMutations } from 'vuex'

import InputGroup from '@/components/inputGroup'
import InputWrapper from '@/components/inputWrapper'

export default {
  name: 'RegistrationAway',
  props: {
    encryptedData: {
      type: String,
      required: true
    },
    contractId: {
      type: String,
      required: true
    },
    contractId2: {
      type: String,
      required: true
    },
    contractName: {
      type: String,
      required: true
    }
  },
  components: {
    InputWrapper,
    InputGroup
  },
  setup() {
    const toast = useToast()
    const router = useRouter()
    return { toast, router }
  },
  data() {
    return {
      cpfError: false,
      isLoading: true,
      modalTermsVisible: false,
      termsAgreed: false,
      password: null,
      phone: null,
      email: null,
      name: null,
      crm: null,
      cpf: null,
      contract: null,
      localContractId: null,
      localContractId2: null,
      decodedContractName: null,
      hasAvailableVoucher: false,
      // eslint-disable-next-line camelcase
      uf_crm: null,
      ufOptions: [
        { label: 'AC', value: 'AC' },
        { label: 'AL', value: 'AL' },
        { label: 'AP', value: 'AP' },
        { label: 'AM', value: 'AM' },
        { label: 'BA', value: 'BA' },
        { label: 'CE', value: 'CE' },
        { label: 'DF', value: 'DF' },
        { label: 'ES', value: 'ES' },
        { label: 'GO', value: 'GO' },
        { label: 'MA', value: 'MA' },
        { label: 'MT', value: 'MT' },
        { label: 'MS', value: 'MS' },
        { label: 'MG', value: 'MG' },
        { label: 'PA', value: 'PA' },
        { label: 'PB', value: 'PB' },
        { label: 'PR', value: 'PR' },
        { label: 'PE', value: 'PE' },
        { label: 'PI', value: 'PI' },
        { label: 'RJ', value: 'RJ' },
        { label: 'RN', value: 'RN' },
        { label: 'RS', value: 'RS' },
        { label: 'RO', value: 'RO' },
        { label: 'RR', value: 'RR' },
        { label: 'SC', value: 'SC' },
        { label: 'SP', value: 'SP' },
        { label: 'SE', value: 'SE' },
        { label: 'TO', value: 'TO' }
      ]
    }
  },
  computed: {
    ...mapGetters('user', ['isRegistred']),
    ...mapGetters('contractClinicalCases', ['getContract']),

    isSaveDisabled() {
      return (
        !this.email ||
        !this.phone ||
        !this.cpf ||
        !this.name ||
        !this.uf_crm ||
        !this.termsAgreed
      )
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        this.localContractId = to.params.contractId
        this.localContractId2 = to.params.contractId2
        this.decodedContractName = decodeURIComponent(to.params.contractName)
      }
    },
    getContract(newContract) {
      if (newContract && newContract.length > 0) {
        this.contract = newContract[0]
      }
    }
  },
  async mounted() {
    this.decryptData()
    console.log('ContractId recebido:', this.localContractId2)
    this.isLoading = true
    await this.checkAvailableVouchers()
    this.isLoading = false
    console.log('hasAvailableVoucher:', this.hasAvailableVoucher)
  },
  methods: {
    redirectToLogin() {
      this.router.push('/login')
    },
    decryptData() {
      console.log('Dados encriptados recebidos:', this.encryptedData)
      try {
        const decodedData = decodeURIComponent(this.encryptedData)
        console.log('Dados decodificados:', decodedData)

        const decryptedBytes = CryptoJS.AES.decrypt(
          decodedData,
          'chave_secreta'
        )
        console.log('Bytes decriptados:', decryptedBytes)

        const decryptedText = decryptedBytes.toString(CryptoJS.enc.Utf8)
        console.log('Texto decriptado:', decryptedText)

        if (!decryptedText) {
          throw new Error('Dados decriptografados estão vazios')
        }

        const decryptedData = JSON.parse(decryptedText)

        this.localContractId = decryptedData.selectContract
        this.localContractId2 = decryptedData.contractId
        this.decodedContractName = decryptedData.contractName

        console.log('Dados decriptografados com sucesso:', decryptedData)
      } catch (error) {
        console.error('Erro ao decriptografar dados:', error)
      }
    },
    ...mapActions('clinicalCaseConsultation', [
      'fetchVoucherAll',
      'allocateVoucherForDoctor'
    ]),
    ...mapMutations('login', ['setUserSelected']),
    ...mapActions('contractClinicalCases', ['fetchContract']),
    ...mapActions('registration', ['createClientDoctor']),
    validateCPF() {
      if (!this.cpf) {
        this.cpfError = false
        return
      }

      const cpf = this.cpf.replace(/[^\d]+/g, '')

      if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) {
        this.cpfError = true
        return
      }

      let sum = 0
      let remainder

      for (let i = 1; i <= 9; i++) {
        sum = sum + parseInt(cpf.substring(i - 1, i)) * (11 - i)
      }

      remainder = (sum * 10) % 11

      if (remainder === 10 || remainder === 11) {
        remainder = 0
      }

      if (remainder !== parseInt(cpf.substring(9, 10))) {
        this.cpfError = true
        return
      }

      sum = 0
      for (let i = 1; i <= 10; i++) {
        sum = sum + parseInt(cpf.substring(i - 1, i)) * (12 - i)
      }

      remainder = (sum * 10) % 11

      if (remainder === 10 || remainder === 11) {
        remainder = 0
      }

      if (remainder !== parseInt(cpf.substring(10, 11))) {
        this.cpfError = true
        return
      }

      this.cpfError = false
    },

    async checkAvailableVouchers() {
      try {
        const response = await this.fetchVoucherAll({
          contractId: this.localContractId2
        })

        this.hasAvailableVoucher = response.totalVoucherAavailable > 0

        console.log(
          'Total de vouchers disponíveis:',
          response.totalVoucherAavailable
        )
        console.log('hasAvailableVoucher:', this.hasAvailableVoucher)
      } catch (error) {
        console.error('Erro ao buscar vouchers:', error)
        this.toast.error('Erro ao verificar disponibilidade de vouchers')
      }
    },

    openModal() {
      this.modalTermsVisible = true
    },
    closeModal() {
      this.modalTermsVisible = false
    },
    handleTerms() {
      this.termsAgreed = true

      this.closeModal()
    },
    async handleSave() {
      const userData = {
        type: 'client_doctor',
        username: this.name?.replace(/\s/g, '').toLowerCase(),
        password: this.password,
        term: this.termsAgreed,
        email: this.email,
        phone: this.phone,
        name: this.name,
        crm: this.crm,
        cpf: this.cpf,
        // eslint-disable-next-line camelcase
        uf_crm: this.uf_crm,
        contractId: this.$route.params.contractId,
        contractName: this.$route.params.contractName
      }

      try {
        const { data } = await this.createClientDoctor(userData)
        const { idUser } = data

        // Agora vamos alocar o voucher usando o idUser
        await this.allocateVoucherForDoctor({
          contractId: this.localContractId2,
          clientDoctorId: idUser
        })

        this.toast.info('Você será redirecionado para a página de login', {
          timeout: 3000
        })

        this.name = null
        this.password = null
        this.termsAgreed = null
        this.email = null
        this.phone = null
        // eslint-disable-next-line camelcase
        this.uf_crm = null
        this.crm = null
        this.cpf = null

        setTimeout(() => {
          this.$router.push({
            path: '/login',
            query: { type: 'client_doctor' }
          })
        }, 3000)
      } catch (error) {
        console.error('Erro ao salvar o cadastro:', error)
      }

      this.password = null
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../styles/index.scss';

.content-title {
  display: flex;
  place-items: flex-start;
  margin: 10px 0;
}
.no-vouchers-message {
  margin-top: 20px;
}
.loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
.error-message {
  color: red;
  font-size: 0.8em;
  margin-top: 5px;
}
.button-container {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
</style>
